// extracted by mini-css-extract-plugin
export default {"Avator":"OffersAndPromotions_Avator__CwbB5"};